import { render, staticRenderFns } from "./TwoTabs.vue?vue&type=template&id=fa73178e&lang=pug"
import script from "./TwoTabs.vue?vue&type=script&lang=js"
export * from "./TwoTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports